<template>
  <div class="person-ranking">
    <ranking-list :items="leaderboards" />
    <transition name="fade-in-up" appear>
      <div class="current-ranking">
        <div class="me">我</div>
        <div class="image">
          <webp-image :src="mine.icon" alt="avatar" width="100%" height="100%" />
        </div>
        <div class="name">{{ mine.name }}<br/><small>第 {{mine.ranking}} 名</small></div>
        <div class="course">{{ duration2course(mine.duration) }}</div>节
      </div>
    </transition>
  </div>
</template>

<script>
  import actions from '@/store/action-types'

  import WebpImage from '@/components/common/WebpImage'
  import RankingList from '@/components/RankingList'

  export default {
    name: 'person-ranking',
    computed: {
      basicDonateDuration () {
        return this.$store.state.BASIC_DONATE_DURATION
      },
      mine () {
        return this.$store.state.leaderboard.person.mine
      },
      leaderboards () {
        return this.$store.state.leaderboard.person.leaderboards
      }
    },
    activated () {
      this.getPersonLeaderboard()
    },
    methods: {
      duration2course (duration) {
        return Math.floor(duration / this.basicDonateDuration)
      },
      getPersonLeaderboard () {
        this.$store.dispatch(actions.fetch.PERSON_LEADERBOARD)
      },
      gotoGroups () {
        this.$router.push('groups')
      }
    },
    components: {
      WebpImage,
      RankingList
    }
  }
</script>

<style lang="scss" scoped>
  @import "../assets/scss/vars";

  .person-ranking {
    background-color: $white;
    .current-ranking {
      position: fixed;
      left: 0;
      bottom: 0;
      z-index: 12;
      display: flex;
      width: 100%;
      height: 130px;
      padding: 25px 40px;
      font-size: 28px;
      color: $white;
      line-height: 80px;
      background-color: $red;
      box-sizing: border-box;
      .me {
        position: absolute;
        width: 55px;
        font-size: 30px;
      }
      .image {
        width: 80px;
        height: 80px;
        margin-left: 65px;
        margin-right: 30px;
        font-size: 0;
        text-align: center;
        border-radius: 50%;
        overflow: hidden;
      }
      .name {
        @include text-ellipsis;
        flex: 1;
        font-size: 30px;
        line-height: 40px;
        small {
          font-size: 28px;
          color: rgba($white, 0.87);
        }
      }
      .course {
        margin-right: 10px;
        font-size: 48px;
        font-weight: 400;
      }
    }
  }
  .fade-in-up-enter-active {
    transition: all 0.5s 0.5s ease-in;
  }
  .fade-in-up-enter {
    transform: translate3d(0, 100%, 0);
  }
</style>



// WEBPACK FOOTER //
// PersonRanking.vue?73b807a8